/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { SingleAuthorTemplate } from "../single-author";
import { getAuthorNameKeyword, getDevider } from "../utils";

import "./hero-overlay-single-author.m.css";

export function HeroOverlaySingleAuthorTemplate(props) {
  const photoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getDevider(),
    hideImage: true
  });

  return (
    <div styleName="hero-overlay-single-author">
      <SingleAuthorTemplate {...photoPriorityPropsObj} />
    </div>
  );
}
